import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, ArrowLeft, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches payment feature flag from backend. Defaults to disabled until known.
export function usePaymentsEnabled() {
  const [state, setState] = useState({ loading: true, enabled: false, message: "" });
  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/config/payments`)
      .then((res) => {
        if (active) setState({ loading: false, enabled: !!res.data?.enabled, message: res.data?.message || "" });
      })
      .catch(() => {
        if (active) setState({ loading: false, enabled: false, message: "Fitur pembayaran sedang dinonaktifkan sementara." });
      });
    return () => {
      active = false;
    };
  }, []);
  return state;
}

// Inline banner for product/checkout pages. Renders nothing while loading or when enabled.
export function PaymentDisabledBanner() {
  const { loading, enabled, message } = usePaymentsEnabled();
  if (loading || enabled) return null;
  return (
    <div
      data-testid="payment-disabled-banner"
      className="flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900"
    >
      <Clock className="mt-0.5 h-5 w-5 shrink-0" />
      <div className="text-sm">
        <p className="font-semibold">Pembayaran Segera Hadir</p>
        <p className="text-amber-800">{message || "Fitur pembayaran sedang dinonaktifkan sementara."}</p>
      </div>
    </div>
  );
}

// Full-page placeholder used to gate pure checkout routes.
export function PaymentComingSoon() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="payment-coming-soon"
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-slate-50 px-6 text-center"
    >
      <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-amber-100 text-amber-600">
        <Wallet className="h-10 w-10" />
      </div>
      <div className="max-w-md space-y-2">
        <h1 className="text-3xl font-bold text-slate-900">Pembayaran Segera Hadir</h1>
        <p className="text-slate-600">
          Fitur pembayaran sedang dinonaktifkan sementara. Fitur lainnya tetap dapat digunakan seperti biasa.
        </p>
      </div>
      <Button data-testid="payment-coming-soon-back-btn" onClick={() => navigate(-1)} className="gap-2">
        <ArrowLeft className="h-4 w-4" /> Kembali
      </Button>
    </div>
  );
}

// Route wrapper: shows placeholder when payments are disabled, else the real page.
export function PaymentGate({ children }) {
  const { loading, enabled } = usePaymentsEnabled();
  if (loading) return null;
  return enabled ? children : <PaymentComingSoon />;
}
